/* Kolab: the gift card amount is picked with a slider, like a volume control.
   The theme's own radio buttons stay in the page, hidden, so the price, the
   variant and the cart keep working exactly as before. */
(() => {
  const CSS = `
  .kolab-amount { display: block; margin: var(--space-2, 12px) 0 var(--space-3, 16px) }
  .kolab-amount .ka-top { display: flex; align-items: baseline; justify-content: space-between; gap: 12px }
  .kolab-amount .ka-label { color: #6c6e65; font-size: 1.2rem; letter-spacing: .02em }
  .kolab-amount .ka-value { font-size: 3.2rem; font-weight: 500; letter-spacing: -.02em; line-height: 1.1 }
  .kolab-amount input[type=range] { -webkit-appearance: none; appearance: none; width: 100%; height: 34px; background: transparent; margin: 6px 0 0; display: block }
  .kolab-amount input[type=range]:focus { outline: none }
  .kolab-amount input[type=range]::-webkit-slider-runnable-track { height: 6px; border-radius: 999px;
    background: linear-gradient(to right, #6db2e2 var(--ka-fill, 0%), #d8d8d0 var(--ka-fill, 0%)) }
  .kolab-amount input[type=range]::-moz-range-track { height: 6px; border-radius: 999px;
    background: linear-gradient(to right, #6db2e2 var(--ka-fill, 0%), #d8d8d0 var(--ka-fill, 0%)) }
  .kolab-amount input[type=range]::-webkit-slider-thumb { -webkit-appearance: none; appearance: none; width: 28px; height: 28px;
    margin-top: -11px; border-radius: 50%; background: #fff; border: 2px solid #6db2e2; box-shadow: 0 1px 4px rgba(0,0,0,.18); cursor: grab }
  .kolab-amount input[type=range]::-moz-range-thumb { width: 28px; height: 28px; border-radius: 50%; background: #fff;
    border: 2px solid #6db2e2; box-shadow: 0 1px 4px rgba(0,0,0,.18); cursor: grab }
  .kolab-amount input[type=range]:active::-webkit-slider-thumb { cursor: grabbing }
  .kolab-amount .ka-ends { display: flex; justify-content: space-between; color: #6c6e65; font-size: 1.1rem; margin-top: 2px }
  .kolab-amount .ka-steps { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px }
  .kolab-amount .ka-steps button { border: 1px solid #d8d8d0; background: transparent; color: #222820; border-radius: 999px;
    padding: 6px 12px; font-size: 1.2rem; cursor: pointer }
  .kolab-amount .ka-steps button[aria-pressed="true"] { border-color: #222820; background: #222820; color: #fff }
  .kolab-hidden-swatches { display: none !important }
  /* The video fills the square media frame, like the packshots. */
  .product__media-item deferred-media { position: relative; aspect-ratio: 1 / 1; overflow: hidden; display: block }
  .product__media-item deferred-media > link { display: none !important }
  .product__media-item deferred-media component-loader,
  .product__media-item deferred-media video-player { display: block; width: 100% !important; height: 100% !important }
  .product__media-item deferred-media video { display: block; width: 100% !important; height: 100% !important; object-fit: cover }
  .product__media-item deferred-media img { width: 100%; height: 100%; object-fit: cover }

  /* Send as a gift: one calm block, with room before the buy button. */
  .recipient-form { display: block; margin: 12px 0 20px !important }
  .recipient-form *, .recipient-form *::before { box-sizing: border-box }
  .recipient-form > input.recipient-checkbox { position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none }
  .recipient-form > label.recipient-checkbox { display: flex; align-items: center; gap: 10px; width: 100%; cursor: pointer;
    border: 1px solid #d8d8d0; padding: 14px 16px; font-size: 1.4rem; color: #222820; margin: 0 }
  .recipient-form > label.recipient-checkbox::before { content: ""; width: 18px; height: 18px; flex: 0 0 18px;
    border: 1px solid #222820; background: #fff }
  .recipient-form > input.recipient-checkbox:checked ~ label.recipient-checkbox { border-color: #222820; border-bottom: 0 }
  .recipient-form > input.recipient-checkbox:checked ~ label.recipient-checkbox::before { background: #6db2e2; border-color: #222820 }
  .recipient-form #gift-cart-form { width: 100%; border: 1px solid #222820; border-top: 1px solid #d8d8d0;
    padding: 18px 16px 20px; margin: 0; gap: 14px; background: #fff }
  .recipient-form #gift-cart-form x-cell, .recipient-form #gift-cart-form x-field { display: block; width: 100%; max-width: 100% }
  .recipient-form #gift-cart-form label { display: none !important }
  .recipient-form .kolab-field-label { display: block; font-size: 1.1rem; letter-spacing: .04em; text-transform: uppercase;
    color: #6c6e65; margin: 0 0 6px }
  .recipient-form input[type=email], .recipient-form input[type=text], .recipient-form input[type=date], .recipient-form textarea {
    width: 100%; background: #fff; border: 1px solid #d8d8d0; border-radius: 0; padding: 13px 14px; font-size: 1.4rem;
    color: #222820; font-family: inherit }
  .recipient-form textarea { min-height: 96px; resize: vertical }
  .recipient-form input:focus, .recipient-form textarea:focus { outline: none; border-color: #6db2e2;
    box-shadow: 0 0 0 2px rgba(109,178,226,.25) }
  .recipient-form .kolab-help { display: flex; justify-content: space-between; gap: 10px; font-size: 1.1rem;
    color: #6c6e65; margin: 6px 0 0 }
  .recipient-form .kolab-two { display: flex; flex-wrap: wrap; gap: 14px }
  .recipient-form .kolab-two > * { flex: 1 1 220px; min-width: 0 }
`;

  const build = (fieldset) => {
    if (fieldset.dataset.kolabAmount) return;
    const radios = [...fieldset.querySelectorAll('input[type=radio]')];
    if (radios.length < 3) return;
    fieldset.dataset.kolabAmount = '1';

    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    const group = fieldset.querySelector('.swatch-group') || radios[0].closest('x-flex');
    if (group) group.classList.add('kolab-hidden-swatches');

    const wrap = document.createElement('div');
    wrap.className = 'kolab-amount';
    const legend = fieldset.querySelector('legend');
    const labelText = (legend && legend.textContent.trim()) || 'Amount';
    if (legend) legend.style.display = 'none';

    const values = radios.map((r) => r.value.trim());
    const quick = [values[0], values[Math.round((values.length - 1) / 3)], values[Math.round(((values.length - 1) * 2) / 3)], values[values.length - 1]]
      .filter((v, i, a) => a.indexOf(v) === i);

    wrap.innerHTML = `
      <div class="ka-top"><span class="ka-label">${labelText}</span><span class="ka-value"></span></div>
      <input type="range" min="0" max="${radios.length - 1}" step="1" value="0" aria-label="${labelText}">
      <div class="ka-ends"><span>${values[0]}</span><span>${values[values.length - 1]}</span></div>
      <div class="ka-steps">${quick.map((v) => `<button type="button" data-v="${v}">${v}</button>`).join('')}</div>`;

    const range = wrap.querySelector('input[type=range]');
    const value = wrap.querySelector('.ka-value');
    const steps = [...wrap.querySelectorAll('.ka-steps button')];

    const paint = (i) => {
      value.textContent = values[i];
      range.style.setProperty('--ka-fill', (i / (radios.length - 1)) * 100 + '%');
      steps.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.v === values[i])));
    };
    const pick = (i, tell) => {
      const radio = radios[i];
      if (!radio) return;
      if (tell && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (range.value !== String(i)) range.value = String(i);
      paint(i);
    };

    range.addEventListener('input', () => pick(Number(range.value), true));
    steps.forEach((b) => b.addEventListener('click', () => pick(values.indexOf(b.dataset.v), true)));
    // The theme can swap the variant on its own, for instance from a link with ?variant=
    radios.forEach((r, i) => r.addEventListener('change', () => { if (r.checked) pick(i, false); }));

    pick(Math.max(0, radios.findIndex((r) => r.checked)), false);
    group ? group.parentNode.insertBefore(wrap, group) : fieldset.appendChild(wrap);
  };


  // Send as a gift: labels above each field, in the shopper's language.
  const FORM_TEXT = {
    pt: { email: 'Email de quem recebe', name: 'Nome de quem recebe (opcional)', message: 'Mensagem (opcional)',
          date: 'Enviar no dia (opcional)', help: 'Enviamos o cartão por email nesse dia. Sem data, segue assim que a encomenda ficar paga.',
          count: 'até 200 caracteres' },
    en: { email: 'Recipient email', name: 'Recipient name (optional)', message: 'Message (optional)',
          date: 'Send on (optional)', help: 'We email the card on that day. With no date, it goes as soon as the order is paid.',
          count: '200 characters max' },
    es: { email: 'Email de quien lo recibe', name: 'Nombre (opcional)', message: 'Mensaje (opcional)', date: 'Enviar el día (opcional)',
          help: 'Enviamos la tarjeta por correo ese día. Sin fecha, sale en cuanto se pague el pedido.', count: 'hasta 200 caracteres' },
    fr: { email: 'E-mail du destinataire', name: 'Nom (facultatif)', message: 'Message (facultatif)', date: "Envoyer le (facultatif)",
          help: "Nous envoyons la carte par e-mail ce jour-là. Sans date, elle part dès que la commande est payée.", count: '200 caractères maximum' },
    it: { email: 'Email di chi la riceve', name: 'Nome (facoltativo)', message: 'Messaggio (facoltativo)', date: 'Inviare il (facoltativo)',
          help: 'Inviamo la carta via email in quel giorno. Senza data, parte appena l ordine è pagato.', count: 'massimo 200 caratteri' },
    de: { email: 'E-Mail der beschenkten Person', name: 'Name (optional)', message: 'Nachricht (optional)', date: 'Senden am (optional)',
          help: 'Wir senden die Karte an diesem Tag per E-Mail. Ohne Datum geht sie ab, sobald die Bestellung bezahlt ist.', count: 'maximal 200 Zeichen' },
  };
  const dressForm = (form) => {
    if (form.dataset.kolabForm) return;
    form.dataset.kolabForm = '1';
    const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    const t = FORM_TEXT[lang] || FORM_TEXT.en;
    const box = form.querySelector('#gift-cart-form');
    if (!box) return;
    const label = (el, text) => {
      if (!el || el.dataset.kolabLabelled) return;
      el.dataset.kolabLabelled = '1';
      const cell = el.closest('x-cell') || el.parentElement;
      const l = document.createElement('span');
      l.className = 'kolab-field-label';
      l.textContent = text;
      cell.insertBefore(l, cell.firstChild);
      el.removeAttribute('placeholder');
    };
    const email = box.querySelector('input[type=email]');
    const name = box.querySelector('input[name*="Recipient name"]');
    const msg = box.querySelector('textarea');
    const date = box.querySelector('input[type=date]');
    label(email, t.email); label(name, t.name); label(msg, t.message); label(date, t.date);
    if (email && name && !box.querySelector('.kolab-two')) {
      const two = document.createElement('div');
      two.className = 'kolab-two';
      const a = email.closest('x-cell'), b = name.closest('x-cell');
      a.parentNode.insertBefore(two, a); two.append(a, b);
    }
    if (msg && !msg.parentNode.querySelector('.kolab-help')) {
      const cell = msg.closest('x-cell');
      [...cell.querySelectorAll('*')].forEach((el) => {
        if (el.children.length === 0 && /characters max|caracteres/i.test(el.textContent)) el.remove();
      });
      const help = document.createElement('div');
      help.className = 'kolab-help';
      const left = document.createElement('span'); left.textContent = t.count;
      const right = document.createElement('span'); right.textContent = '0 / 200';
      help.append(left, right); cell.appendChild(help);
      msg.addEventListener('input', () => { right.textContent = `${msg.value.length} / 200`; });
    }
    if (date && !date.parentNode.querySelector('.kolab-date-help')) {
      const cell = date.closest('x-cell');
      const p = document.createElement('p');
      p.className = 'kolab-help kolab-date-help';
      p.textContent = t.help;
      cell.appendChild(p);
    }
  };
  const scan = () => { document.querySelectorAll('fieldset.product-form__input').forEach(build); document.querySelectorAll('recipient-form').forEach(dressForm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
